import React from "react";
import "../styles/about.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faCamera , faImage , faHdd, faClock, faPhone, faLaptop } from '@fortawesome/free-solid-svg-icons';

function About() {
  return (
    <div id="about" className="about-block">
      <div className="extra">
      <h2 className="section-title">Wedding Stories Advantages</h2>
      <div className="section-line" aria-hidden="true" />
      <div className="plan-des section-lead">
        <p>
          We blend technical excellence with artistic vision to bring your dream wedding to life.
        </p>
      </div>


      <div id="about-container" className="scroll-animate-stagger">
        <div className="benifit-container">
          <div className="icon">
            <FontAwesomeIcon icon={faCamera} />
          </div>
          <div className="desc"><span>Premium Imaging Equipment</span> Utilizing industry-leading camera systems to ensure every detail of your day is captured in breathtaking high resolution.</div>
        </div>
        <div className="benifit-container">
          <div className="icon">
          <FontAwesomeIcon icon={faImage} />
          </div>
          <div className="desc"><span>Masterful Lighting</span> Expertly crafted lighting setups that guarantee stunning, cinematic visuals in any environment or weather condition.</div>
        </div>
        <div className="benifit-container">
          <div className="icon">
          <FontAwesomeIcon icon={faLaptop} />
          </div>
          <div className="desc"><span>State-of-the-Art Post-Production</span> Leveraging powerful editing technology to deliver meticulously color-graded and polished galleries.</div>
        </div>
        <div className="benifit-container">
          <div className="icon">
          <FontAwesomeIcon icon={faClock} />
          </div>
          <div className="desc"><span>Guaranteed Timelines</span> Committed to strict delivery schedules so you can relive your memories without the wait.</div>
        </div>
        <div className="benifit-container">
          <div className="icon">
          <FontAwesomeIcon icon={faHdd} />
          </div>
          <div className="desc"><span>Uncompromising Data Security</span> Your memories are safe with our rigorous, high-speed backup protocols and redundant storage systems.</div>
        </div>
        <div className="benifit-container">
          <div className="icon">
          <FontAwesomeIcon icon={faPhone} />
          </div>
          <div className="desc"><span>Dedicated Client Support</span> Always accessible to answer your questions and guide you seamlessly through the planning process.</div>
        </div>
        </div>
      </div>
    </div>
  );
}

export default About;
